export default "__VITE_ASSET__B$BbPClR__"